import { IQuantityPerUnit, PackagingUnitType } from '@alberta/konexi-shared';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'articleQuantityWithUnit',
  pure: true,
  standalone: true,
})
export class ArticleQuantityWithUnitPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}
  transform(quantity: number, packagingUnit: Omit<IQuantityPerUnit, 'archived'>): string {
    let unit = '';
    switch (packagingUnit.unit) {
      case PackagingUnitType.piece:
        unit = this._translate.instant('article.edit.units.stk');
        break;
      case PackagingUnitType.carton:
        unit = `${this._translate.instant('article.edit.units.ktn')} (${packagingUnit.quantity} Stk.)`;
        break;
    }
    return `${quantity} ${unit}`;
  }
}
